import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const CookiesPolicyScreen = () => {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState("idle"); // idle | success | error

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setSubmitting(true);
    setSubmitStatus("idle");

    try {
      const response = await fetch("https://formspree.io/f/xnqebwrj", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          tip: "cookies policy",
          email,
          language: i18n.language,
          pageUrl: typeof window !== "undefined" ? window.location.href : "",
        }),
      });

      if (!response.ok) throw new Error("Error sending data");

      setEmail("");
      setSubmitStatus("success");
    } catch {
      setSubmitStatus("error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ backgroundColor: "#0e3747", minHeight: "70vh", paddingTop: "50px" }}>
      <div className="container" style={{ padding: "3.5rem 1rem", color: "white" }}>
        <h1 style={{ marginBottom: "1rem" }}>{t("cookies_title")}</h1>
        <div style={{ borderBottom: "2px solid #00c613", width: "10rem", marginBottom: "1.5rem" }} />

        <p style={{ color: "#d7d7e2", maxWidth: "900px" }}>{t("cookies_intro")}</p>

        <h2 style={{ marginTop: "2rem", marginBottom: "0.75rem" }}>{t("cookies_s1_title")}</h2>
        <p style={{ color: "#d7d7e2", maxWidth: "900px" }}>{t("cookies_s1_body")}</p>

        <h2 style={{ marginTop: "2rem", marginBottom: "0.75rem" }}>{t("cookies_s2_title")}</h2>
        <ul style={{ color: "#d7d7e2", maxWidth: "900px" }}>
          <li>{t("cookies_s2_item1")}</li>
          <li>{t("cookies_s2_item2")}</li>
          <li>{t("cookies_s2_item3")}</li>
        </ul>

        <h2 style={{ marginTop: "2rem", marginBottom: "0.75rem" }}>{t("cookies_s3_title")}</h2>
        <p style={{ color: "#d7d7e2", maxWidth: "900px" }}>{t("cookies_s3_body")}</p>

        <div
          style={{
            maxWidth: "900px",
            marginTop: "2rem",
            padding: "1.25rem",
            borderRadius: "12px",
            background: "rgba(255,255,255,0.06)",
            border: "1px solid rgba(255,255,255,0.12)",
            backdropFilter: "blur(8px)",
          }}
        >
          <h3 style={{ margin: 0, marginBottom: "0.5rem" }}>{t("cookies_contact_cta_title")}</h3>
          <p style={{ color: "#d7d7e2", marginBottom: "1rem" }}>{t("cookies_contact_cta_text")}</p>

          <form onSubmit={handleSubmit} style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t("Unesite email adresu")}
              required
              style={{
                flex: "1 1 260px",
                minWidth: "260px",
                padding: "0.75rem 1rem",
                borderRadius: "10px",
                border: "1px solid rgba(255,255,255,0.18)",
                background: "rgba(13, 51, 64, 0.65)",
                color: "white",
                outline: "none",
              }}
            />
            <button
              type="submit"
              disabled={submitting}
              style={{
                padding: "0.75rem 1.25rem",
                borderRadius: "10px",
                border: "none",
                background: submitting ? "#6b7280" : "#00c613",
                color: "white",
                fontWeight: 700,
                cursor: submitting ? "not-allowed" : "pointer",
                flex: "0 0 auto",
              }}
            >
              {submitting ? t("Učitavanje...") : t("cookies_contact_submit")}
            </button>
          </form>

          {submitStatus === "success" && (
            <p style={{ marginTop: "0.75rem", marginBottom: 0, color: "#a7f3d0" }}>{t("cookies_contact_success")}</p>
          )}
          {submitStatus === "error" && (
            <p style={{ marginTop: "0.75rem", marginBottom: 0, color: "#fecaca" }}>{t("cookies_contact_error")}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CookiesPolicyScreen;

